import React from "react";
import moment from 'moment';

const TableComponent = ({ selectedCustomer, tableHeaders, tableData }) => {

  return (
    <div className="p-4 bg-white rounded-md border border-[#2121211A]/10">
      <h1 className="text-lg font-semibold mb-4">{selectedCustomer=="Total" || "" ? "Recently Added" : selectedCustomer} Customers</h1>
      <div className="overflow-x-auto ">
        <table className="min-w-full text-sm text-left text-gray-500  border ">
          <thead className="text-black capitalize border-b bg-gray-100">
            <tr className="whitespace-nowrap border-b">
              {tableHeaders.map((header, index) => (
                <th key={index} className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 ">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData && tableData.total != 0 && tableData.list.map((row, index) => (
              <tr key={index} className="bg-white  hover:bg-gray-50 border-b whitespace-nowrap text-[#212121] font-normal">
                <td className="px-4 py-4">{row.id}</td>
                <td className="px-4 py-4"><div className="flex justify-start place-items-center gap-2">{row?.f_name || 'N/A'}</div></td>
                <td className="px-4 py-4">{row.phone || 'N/A'}</td>
                <td className="px-4 py-4">{row.city || 'N/A'}</td>
                <td className="px-4 py-4">{row.weighbridge_id || 'N/A'}</td>
                <td className="px-4 py-4">{row.license_key || 'N/A'}</td>
                <td className="px-4 py-4">{row.referred_by_name || 'N/A'}</td>
                <td className="px-4 py-4">{row.expired_on ? moment(row.expired_on).format('DD/MM/YYYY hh:mm A') : 'N/A'}</td>
                <td className="px-4 py-4">{row.expired_on ? moment(row.last_login).format('DD/MM/YYYY hh:mm A') : 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableComponent;
